/**
 * 功能: 整体slide显示的框架
 */

<template lang="pug">
  div(style='margin:1px 0 0;width:1200px;top: 60px;')
    .content-header
      p.headerP(class="el-icon-time" style='margin-right:20px') {{brief.releaseDate | getTime}}
      p.headerP(class="fa fa-info-circle") version:{{brief.version}}
    .main#content-main(:class="[fullwebpageShow ? '' :'third']" style=`height:${canvasHeight}px`)
      div(style= `background-color:white;width:${canvasWidth}px;height:${canvasHeight}px` id="canvasDiv" v-loading="isLoading" element-loading-text="内容正在加载中...")
        swiper(:options="swiperOption" ref="mySwiper" @slideChange="slideChange")
          swiper-slide(v-for="i in slideArr" :key="i._id" )
            canvasSlide(ref="canvasslide" :slide="i" @showMemo="showMemo" @showAttachment="showAttachment" @changecanvasWidth="changecanvasWidth")
        img.toleft(src="@/images/slide_arrow.svg" )
        img.toright(src="@/images/slide_arrow.svg" )
        .changeSize(@mousemove="changeSize" @mouseleave="changeSizeLeave" :class="[ischangeSize ? 'showChange' :'hideChange']")
          .wider.cp(v-if="widerShow")
            el-tooltip(class="item" effect="dark" placement="top" content='宽屏模式')
              img(src='@/images/wider.svg' style="cursor: pointer;" @click="wider" )
          .fullwebpage.cp(v-if="fullwebpageShow")
            el-tooltip(class="item" effect="dark" placement="top" content='网页全屏')
              img(src='@/images/fullwebpage.svg' style="cursor: pointer;" @click="fullwebpage" )
          .fullscreen.cp#fullscreen(v-if="fullscreenShow")
            el-tooltip(class="item" effect="dark" placement="top" content='全屏模式')
              img(src='@/images/fullscreen.svg' style="cursor: pointer;" @click="fullscreen" )
      el-dialog(:visible.sync="dialogVisible" :title="`${elementData.explain} ${elementData.title || elementDialogTitle || ''}`" width="70%" :modal="ismodel")
        elementDialog(:elementData="elementData")
      memoDialog(ref="memoDialog" :isDisabled="true" :relativeId="this.relativeId")
    .fotter
      //- p.headerL(style='font-size:12px;color: rgb(140, 140, 140);') 头豹发布的报告(包括但不限于报告含的数据、文字、图表、图像等)，著作权均归发布者所有。
      p(style='position: absolute;right: 0;') {{imageIndex}}/{{slideArr.length}}
      .preview-footer
        ul
          li 本报告著作权归发布者所有，未经书面许可，任何机构或个人不得以任何形式翻版、复刻、发表或引用。若征得发布者及头豹同意进行引用、刊发的，需在允许的范围内使用，并注明出处为“头豹研究院”，且不得对本报告进行任何有悖原意的引用、删节或修改。
          li 本报告分析师具有专业研究能力，保证报告数据均来自合法合规渠道，观点产出及数据分析基于分析师对行业的客观理解，本报告不受任何第三方授意或影响。
          li 本报告所涉及的观点或信息仅供参考，不构成任何投资建议。本报告仅在相关法律许可的情况下发放，并仅为提供信息而发放，概不构成任何广告。在法律许可的情况下，发布者或头豹可能会为报告中提及的企业提供或争取提供投融资或咨询等相关服务。本报告所指的公司或投资标的的价值、价格及投资收入可升可跌。
          li 本报告的部分信息来源于公开资料，发布者对该等信息的准确性、完整性或可靠性不做任何保证。本文所载的资料、意见及推测仅反映发布者于发布本报告当日的判断，过往报告中的描述不应作为日后的表现依据。在不同时期，发布者或头豹可发出与本文所载资料、意见及推测不一致的报告和文章。发布者或头豹均不保证本报告所含信息保持在最新状态。同时，发布者对本报告所含信息可在不发出通知的情形下做出修改，读者应当自行关注相应的更新或修改。任何机构或个人应对其利用本报告的数据、分析、研究、部分或者全部内容所进行的一切活动负责并承担该等活动所导致的任何损失或伤害。
</template>

<script>
import { parseTime } from '@/javascripts/time'
import elementDialog from './elementDialog'
import canvasSlide from './canvas'
import memoDialog from '@/components/dialog'
import 'swiper/css/swiper.css'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
export default {
  name: 'Slide',
  props: {
    brief: { type: Object, default: () => {} }
  },
  components: {
    elementDialog, memoDialog, Swiper, SwiperSlide, canvasSlide
  },
  data () {
    return {
      slideArr: [],
      canvasWidth: 1200,
      canvasHeight: 838,
      imageObj: {},
      imageIndex: 1,
      isLoading: false,
      dialogVisible: false,
      elementData: {},
      elementInfo: false,
      elementDialogTitle: '',
      relativeId: '',
      ischangeSize: false,
      fullscreenShow: true,
      fullwebpageShow: true,
      widerShow: false,
      ismodel: true,
      isEsc: false,
      swiperOption: {
        navigation: {
          nextEl: '.toright',
          prevEl: '.toleft'
        }
      }
    }
  },
  methods: {
    findImageIndex (imageObj) {
      for (let i = 0; i < this.slideArr.length; i++) {
        if (this.slideArr[i]._id === imageObj._id) {
          return i
        }
      }
    },
    // 显示slide底部可以放大缩小的按钮
    changeSize () {
      this.ischangeSize = true
    },
    // 隐藏slide底部可以放大缩小的按钮
    changeSizeLeave () {
      this.ischangeSize = false
    },
    // 宽屏显示slide
    wider () {
      if (!this.fullscreenShow) {
        this.exitFullScreen()
      }
      this.$refs.canvasslide[this.swiper.activeIndex].drawImage('widerShow')
      this.ismodel = true
      this.fullwebpageShow = true
      this.widerShow = false
      this.fullscreenShow = true
      for (let i = 0; i < this.slideArr.length; i++) {
        this.$refs.canvasslide[i].drawImage('widerShow')
      }
      this.$emit('mode', false)
    },
    // 网页全屏显示slide
    fullwebpage () {
      if (!this.fullscreenShow) {
        this.exitFullScreen()
        this.wider()
      }
      this.$refs.canvasslide[this.swiper.activeIndex].drawImage('fullwebpageShow')
      for (let i = 0; i < this.slideArr.length; i++) {
        this.$refs.canvasslide[i].drawImage('fullwebpageShow')
      }
      this.ismodel = false
      this.fullwebpageShow = false
      this.widerShow = true
      this.fullscreenShow = true
      this.$emit('mode', true)
    },
    // 屏幕全屏显示
    fullscreen () {
      if (!this.fullwebpageShow) {
        this.wider()
      }
      this.$nextTick(() => {
        this.$refs.canvasslide[this.swiper.activeIndex].drawImage('fullscreenShow')
        for (let i = 0; i < this.slideArr.length; i++) {
          this.$refs.canvasslide[i].drawImage('fullscreenShow')
        }
      })
      this.ismodel = false
      this.fullwebpageShow = true
      this.widerShow = true
      this.fullscreenShow = false
      const full = document.getElementById('content-main')
      this.fullScreen(full)
      this.isEsc = true
      this.$emit('mode', false)
    },
    // 执行网页全屏
    fullScreen (el) {
      var rfs = el.requestFullScreen || el.webkitRequestFullScreen || el.mozRequestFullScreen || el.msRequestFullScreen
      if (typeof rfs !== 'undefined' && rfs) {
        rfs.call(el)
      }
    },
    // 退出全屏
    exitFullScreen () {
      var el = document
      var cfs = el.cancelFullScreen || el.webkitCancelFullScreen || el.mozCancelFullScreen || el.exitFullScreen

      if (typeof cfs !== 'undefined' && cfs) {
        cfs.call(el)
      }
    },
    // 当前显示状态
    isMode () {
      if (document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement) {
        return null
      } else {
        this.wider()
      }
    },
    // 显示备忘
    showMemo (e) {
      this.relativeId = e
      this.$refs.memoDialog.show()
    },
    // 显示附件弹框
    showAttachment (e) {
      if (e) {
        this.dialogVisible = true
        this.elementData = e
        this.elementDialogTitle = e.attachment.newTitle || e.attachment.title
      }
    },
    // slide翻页
    slideChange () {
      this.imageIndex = this.swiper.activeIndex + 1
      this.$refs.canvasslide[this.swiper.activeIndex].drawImage()
    },
    // 改变绘制slide位置的宽度
    changecanvasWidth (w, h, id) {
      const index = this.findImageIndex({ _id: id })
      if (this.swiper.activeIndex === index) {
        this.canvasWidth = w
        this.canvasHeight = h
        document.getElementsByClassName('swiper-wrapper')[0].style.height = h + 'px'
        document.getElementsByClassName('swiper-wrapper')[0].style.width = w + 'px'
        document.getElementById('a' + id).parentNode.style.width = w + 'px'
      }
    }
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiperInstance
    }
  },
  mounted () {
    const self = this
    this.$nextTick(() => {
      document.addEventListener('keyup', () => {
        if (this.widerShow) {
          this.wider()
        }
      })
    })
    this.$bus.$on('slideArr', (e) => {
      this.slideArr = e
    })
    this.$bus.$on('clickOutline', (e) => {
      const index = this.findImageIndex(e.slide[0])
      this.swiper.activeIndex = index
      this.imageIndex = this.swiper.activeIndex + 1
      this.$refs.canvasslide[this.swiper.activeIndex].drawImage()
    })
    this.$bus.$on('handleChangeSlide', (e) => {
      const index = this.findImageIndex({ _id: e })
      this.swiper.activeIndex = index
      this.imageIndex = this.swiper.activeIndex + 1
      this.$refs.canvasslide[this.swiper.activeIndex].drawImage()
    })
    window.addEventListener('resize', function () {
      if (!self.fullscreenShow) {
        self.isMode()
      }
    })
  },
  filters: {
    getTime: function (val) {
      if (!val) {
        return '暂无日期'
      }
      const date = new Date(val)
      return parseTime(date, '{y}-{m}-{d} {h}:{i}')
    }
  },
  watch: {

  }
}
</script>

<style scoped>

.content-header{
  height: 70px;
}
.main{
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.container{
  height: 100%;
  background-color: rgb(250, 250, 250)
}
.headerP{
  display: inline;
  line-height:80px;
  color:#666666;
}
p::before{
  margin: 0 10px;
}
.label:hover,.toleft:hover,.toright:hover{
  cursor: pointer;
}
.swiper-wrapper{
  display: flex;
  justify-content: center;
  position: relative;
}
#mycanvas{
  position: relative;
}
.toleft{
  width: 45px;
  height: 45px;
  position: absolute;
  z-index: 1;
  top: 45%;
  left: 5%;
}
.toright{
  width: 45px;
  height: 45px;
  position: absolute;
  z-index: 1;
  top: 45%;
  right: 5%;
  transform: rotate(180deg);

}
.changeSize{width: 100%; height: 35px; background-color: rgba(0,0,0,0);position: absolute;z-index: 1000;bottom: 0;left: 0;display: flex;justify-content: flex-end;align-items: center;color:white;opacity:0;padding:0 25px 0}
.changeSize img{width:20px;height:20px;}
.showChange{animation:showChange 1s forwards;}
@keyframes showChange
{
from {background-color: rgba(0,0,0,0);opacity:0}
to {background-color: rgba(0,0,0,0.6);opacity:1}
}
.hideChange{animation:hideChange 5s forwards;}
@keyframes hideChange
{
from {background-color: rgba(0,0,0,0.6);opacity:1}
to {background-color: rgba(0,0,0,0);opacity:0}
}
.changeSize>div{width: 20px;height: 20px;margin:0 15px;}
.cp:hover{
  transform: scale(1.3);
}
.third{
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  -webkit-animation: bg 0.2s forwards;
  animation: bg 0.2s forwards;
  width: 100%;
  height: 100%;
  background: black;
}
#canvasDiv{
  /* min-height: 838px; */
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.fotter{
  margin-top: 20px;
  display: flex;
  position: relative;
}
.v-modal{
  z-index: 0 !important;
}
.preview-footer{
  width:1200px;
  margin:30px auto;
  /* margin-top: 60px; */
  border-top: solid 1px;
  border-color:#E8392A;
  /* opacity: 0.06; */
  background: rgba(172, 181, 192,0.06) ;
}
.preview-footer p, .preview-footer ul li{
  /* width:1200px; */
  margin:17px;
  /* margin:0 auto; */
  font-family: PingFangSC-Regular;
  font-size: 0.8rem;
  color: #666666;
  letter-spacing: 0;
  text-align: justify;
  line-height: 22px;
  text-indent: 2.25rem
}
.preview-footer ul{
  padding-bottom: 20px;
}
.preview-footer ul li{
  text-indent: 2rem;
  list-style: disc;
}
</style>
<style>
.el-dialog__title{
  font-size: medium;
  font-weight: bold;
}
/* .swiper-wrapper{
  width: 1200px;
} */
</style>
